export default __webpack_public_path__ + "static/media/prev-GNSS-Antenna-2.43689040.png";